import {
  type MarketingConsent,
  useConsentStore,
} from "@/components/analytics/consent";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { Cookie, X } from "lucide-react";
import { useEffect, useState } from "react";

export function CookieConsent() {
  const [mounted, setMounted] = useState(false);
  const consent = useConsentStore((s) => s.consent);
  const setConsent = useConsentStore((s) => s.setConsent);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // 1. Geliştirme ortamında (localhost / dev) geliştiriciyi gereksiz yere engelleme
  if (import.meta.env.DEV) {
    return null;
  }

  // 2. SSR ve ilk render sırasında null dönerek sayfa yenilenirken banner'ın ekrana patlamasını ve hydration hatasını önle
  if (!mounted) {
    return null;
  }

  // 3. Kullanıcı zaten kabul ettiyse veya reddettiyse ekranda hiçbir şey gösterme
  if (consent && !editing) {
    return null;
  }

  const choose = (value: Exclude<MarketingConsent, null>) => {
    setConsent(value);
    setEditing(false);
  };

  return (
    <aside className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border border-border bg-card/98 p-4 shadow-2xl backdrop-blur sm:p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <Cookie className="hidden h-7 w-7 shrink-0 text-primary sm:block" />
        <div className="flex-1 space-y-1">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold text-foreground text-sm">
              Çerez tercihleri
            </h2>
            <button
              type="button"
              onClick={() => choose("denied")}
              className="text-muted-foreground transition-colors hover:text-foreground sm:hidden"
              aria-label="Kapat"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <p className="text-muted-foreground text-xs leading-relaxed sm:text-sm">
            Zorunlu çerezler sitenin çalışması için kullanılır. İzin verirseniz
            Google ve Meta ölçüm araçları reklam performansını anlamamıza
            yardımcı olur. Tercihinizi daha sonra değiştirebilirsiniz.{" "}
            <Link
              to="/privacy"
              search={{ tab: "privacy" }}
              className="underline hover:text-foreground"
            >
              Gizlilik politikası
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 gap-2 sm:flex-col">
          <Button
            size="sm"
            className="flex-1 font-medium"
            onClick={() => choose("granted")}
          >
            Kabul et
          </Button>
          <Button
            size="sm"
            variant="outline"
            className="flex-1"
            onClick={() => choose("denied")}
          >
            Reddet
          </Button>
        </div>
      </div>
    </aside>
  );
}
